module.exports = require("/Users/raphael.benitte/projects/edikit/website/src/utils/typography.js")